var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 24,
    maskUnits: "userSpaceOnUse",
    width: 24,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "#d9d9d9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7 23c-.55 0-1.02083-.1958-1.4125-.5875s-.5875-.8625-.5875-1.4125v-18c0-.55.19583-1.02083.5875-1.4125s.8625-.5875 1.4125-.5875h10c.55 0 1.0208.19583 1.4125.5875s.5875.8625.5875 1.4125v18c0 .55-.1958 1.0208-.5875 1.4125s-.8625.5875-1.4125.5875zm5-2.5c.2833 0 .5208-.0958.7125-.2875s.2875-.4292.2875-.7125-.0958-.5208-.2875-.7125-.4292-.2875-.7125-.2875-.5208.0958-.7125.2875-.2875.4292-.2875.7125.0958.5208.2875.7125.4292.2875.7125.2875zm-5-4.5h10v-10h-10z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.a1ea4cbca435f5c1ca07a84f2aec8f64.svg";
export { ForwardRef as ReactComponent };